module.exports = __webpack_public_path__ + "img/hoshino_main_mobile.48a91a0a.jpg";